import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { API } from './constants';

@Injectable({ providedIn: 'root' })
export class BankAccountsService extends ApiService {
	getCustomerAccountsBalances() {
		return this.get(`${API.getMyAccountsBalances}`);
	}

	loadAccountInfo(getAccountInfo:string) {
		return this.get(`${API.getAccountInfo}/${getAccountInfo}`);
	}
}
